// app/hooks/useAuth.tsx
import { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged, User } from "firebase/auth";
import { app } from "../_firebase/firebase";

export const useAuth = () => {
  const [authedUser, setAuthedUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth(app);
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setAuthedUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return { authedUser, loading };
};
